import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const serviceProviderList = createAsyncThunk('serviceProvider/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `service_provider`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'type_id': data?.type,
                'sub_type_id': data?.sub_type,
                'is_frequent_visitor': data?.is_frequent_visitor,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const serviceProviderDetails = createAsyncThunk('serviceProvider/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `service_provider/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addServiceProvider = createAsyncThunk('serviceProvider/add', async (data) => {
    var bodyFormData = new FormData()

    bodyFormData.append(
        "premise_id", data?.values?.premise_id
    )
    bodyFormData.append(
        "sp_name", data?.values?.name
    )
    bodyFormData.append(
        "sp_mobile", data?.values?.mobile
    )
    bodyFormData.append(
        "type_id", data?.values?.type
    )
    bodyFormData.append(
        "sub_type_id", data?.values?.sub_type
    )
    bodyFormData.append(
        "validity", data?.values?.validity && moment(data?.values?.validity, 'DD/MM/YYYY').format('YYYY-MM-DD')
    )
    {
        data?.values?.profile &&
            bodyFormData.append(
                "sp_profile", data.values.profile
            )
    }
    bodyFormData.append(
        "status", data?.values?.status
    )

    bodyFormData.append(
        "doc_type", data?.values?.id_type
    )
    bodyFormData.append(
        "doc_id", data?.values?.id_number
    )
    {
        data?.values?.upload_document &&
            bodyFormData.append(
                "doc_file", data.values.upload_document
            )
    }

    bodyFormData.append(
        "sp_present_address", data?.values?.present_address
    )
    bodyFormData.append(
        "sp_permanent_address", data?.values?.permanent_address
    )

    bodyFormData.append(
        "police_verification", data?.values?.police_verification
    )
    bodyFormData.append(
        "is_hireable", data?.values?.is_hireable
    )
    bodyFormData.append(
        "is_frequent_visitor", data?.values?.is_frequent_visitor
    )
    bodyFormData.append(
        "unit_id", Array.isArray(data?.values?.unit_ids) ? data.values.unit_ids.join(',') : ''
    )

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'service_provider',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "service_provider", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateServiceProvider = createAsyncThunk('serviceProvider/update', async (data) => {
    var bodyFormData = new FormData()

    bodyFormData.append(
        "sp_id", data?.values?.id
    )
    bodyFormData.append(
        "premise_id", data?.values?.premise_id
    )
    bodyFormData.append(
        "sp_name", data?.values?.name
    )
    bodyFormData.append(
        "sp_mobile", data?.values?.mobile
    )
    bodyFormData.append(
        "type_id", data?.values?.type
    )
    bodyFormData.append(
        "sub_type_id", data?.values?.sub_type
    )
    bodyFormData.append(
        "validity", data?.values?.validity && moment(data?.values?.validity, 'DD/MM/YYYY').format('YYYY-MM-DD')
    )
    {
        data?.values?.profile &&
            bodyFormData.append(
                "sp_profile", data.values.profile
            )
    }
    bodyFormData.append(
        "status", data?.values?.status
    )

    bodyFormData.append(
        "doc_type", data?.values?.id_type
    )
    bodyFormData.append(
        "doc_id", data?.values?.id_number
    )
    {
        data?.values?.upload_document &&
            bodyFormData.append(
                "doc_file", data.values.upload_document
            )
    }

    bodyFormData.append(
        "sp_present_address", data?.values?.present_address
    )
    bodyFormData.append(
        "sp_permanent_address", data?.values?.permanent_address
    )

    bodyFormData.append(
        "police_verification", data?.values?.police_verification
    )
    bodyFormData.append(
        "is_hireable", data?.values?.is_hireable
    )
    bodyFormData.append(
        "is_frequent_visitor", data?.values?.is_frequent_visitor
    )
    bodyFormData.append(
        "unit_id", Array.isArray(data?.values?.unit_ids) ? data.values.unit_ids.join(',') : ''
    )

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_service_provider',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "service_provider", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delServiceProvider = createAsyncThunk('serviceProvider/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `service_provider/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const serviceProvider = createSlice({
    name: 'serviceProvider',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(serviceProviderList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(serviceProviderDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default serviceProvider.reducer;